
namespace RioERP.Masters {
    export class SmsGatewaySettingsColumns {
        static columnsKey = 'Masters.SmsGatewaySettings';
    }
}